<template>
  <FormulateInput
    v-if="personalizedType !== 'clipartCategory' && isLoadJs"
    type="imagescrabble"
    :name="layer.id"
    :label="label"
    :aspectRatio="aspectRatio"
    :configsScrabble="configsScrabble"
    ,
    :valueDefault="valueDefault"
    :width="width"
    :height="height"
  >
    <template #label="{ label, id }">
      <label :for="id">
        {{ label }}
        <strong v-if="required" style="color: #ff7875;">*</strong>
      </label>
    </template>
  </FormulateInput>
</template>

<script>
import { get } from 'lodash'
export default {
  name: 'ImageScrabbleField',
  props: {
    layer: {
      type: Object,
      required: true
    },
    artwork: {
      type: Object,
      required: true
    },
    personalized: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
      return {
          isLoadJs: false
      }
  },
  created() {
  },
  mounted() {
      this.loadScriptJsCrossword();
  },
  methods: {
    loadScriptJsCrossword() {
        const THIS = this;
        const crosswordJs = document.createElement('script');
        //crosswordJs_value = https://cdn.jsdelivr.net/npm/crossword-layout-generator@0.1.1/src/layout_generator.min.js
        crosswordJs.setAttribute(
            'src',
            'https://d7re1xv4rs2gf.cloudfront.net/assets/layout_generator.min.js'
        );
        crosswordJs.async = true;
        document.head.appendChild(crosswordJs);
        setTimeout(() => {
            THIS.isLoadJs = true;
        }, 1000);
    },
  },
  computed: {
    personalizedType() {
      return this.layer.personalized.type
    },
    required() {
      return get(this.layer, 'personalized.required', false)
    },
    initialValue() {
      const { personalized, layer } = this
      return get(personalized, layer.id)
    },
    label() {
      const { layer } = this
      const maxLength = layer.configsScrabble.maxLength
        ? layer.configsScrabble.maxLength
        : null
      const textLength = maxLength ? ` (Add up to ${maxLength} Names)` : ''
      return (
        get(this.layer, 'personalized.label', this.layer.title) + textLength
      )
    },
    aspectRatio() {
      const { layer } = this
      return layer.width / layer.height
    },
    configsScrabble() {
      return get(this.layer, 'configsScrabble', {})
    },
    valueDefault() {
      return get(this.layer, 'values[0]', null)
    },
    width() {
      return get(this.layer, 'width', 500)
    },
    height() {
      return get(this.layer, 'height', 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Form/ImageScrabbleField.vue